import { render, staticRenderFns } from "./ddRadios.vue?vue&type=template&id=45a2a919"
import script from "./ddRadios.vue?vue&type=script&lang=js"
export * from "./ddRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports